import styled from 'styled-components';
import {Radio} from 'antd';
import {bordersStyles, typographyStyles} from '../../../../utils/styles';

const StyledInvoiceRadioSelector = styled(Radio.Group)`
  width: 100%;

  & > .ant-space {
    width: 100%;
  }
`;

const StyledInvoiceRadioSelectorIcon = styled.div`
  align-items: center;
  display: flex;

  &:hover {
    svg {
      path {
        fill: ${props => props.theme.colors.neutral_7};
      }
    }
  }

  svg {
    height: 16px;
    width: 16px;
    path {
      fill: ${props => props.theme.colors.neutral_10};
      transition: .2s ease;
    }
  }
`

const StyledInvoiceRadioSelectorRadio = styled(Radio)`
  ${bordersStyles.light};
  ${typographyStyles.footnote.description};

  color: ${props => props.theme.colors.neutral_10};
  transition: .2s ease-in;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin-inline-end: 0;
  padding: 12px 10px;
  width: 100%;

  &.ant-radio-wrapper-checked {
    border: 1px solid ${props => props.theme.colors.primary_4};
  }

  .invoice-radio-details-header-title {
    .ant-space-item {
      display: flex;
      align-items: center;
    }
  }

  & > .ant-space {
    width: 100%;
  }

  & > span {
    &:not(.ant-radio) {
      padding-inline-start: 0;
    }
  }

  &:after {
    content: none;
  }

  &:hover {
    background: ${(props) => props.theme.colors.primary_5}19;
  }

  .date {
    color: ${props => props.theme.colors.neutral_8};
  }

  .placeholder {
    height: 42px;
    width: 42px;
  }
`;

export {
  StyledInvoiceRadioSelector,
  StyledInvoiceRadioSelectorIcon,
  StyledInvoiceRadioSelectorRadio,
};
